import { laptopRatio, mobileRatio, theme } from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const lineChartStyle = (seriesColor, seriesTextColor) => ({
  lineChart: {
    '& .apexcharts-xaxis-label, .apexcharts-yaxis-label': {
      fontSize: getResponsiveSize(14), // 14px
      fontWeight: 500,
      color: theme.palette.neutral.grey70,
    },
    '& .tooltip-sparkline': {
      background: theme.palette.myPrimary.white,
      border: `2px solid ${seriesColor}`,
      borderRadius: getResponsiveSize(8), // 8px
      color: seriesTextColor,
    },
    // Laptop screen
    [theme.breakpoints.media.laptop]: {
      '& .apexcharts-xaxis-label, .apexcharts-yaxis-label': {
        fontSize: getResponsiveSize(13, laptopRatio), // 13px
      },
      '& .tooltip-sparkline': {
        borderRadius: getResponsiveSize(8, laptopRatio), // 8px
        '& span': {
          fontSize: getResponsiveSize(15, laptopRatio), // 15px
        },
      },
    },
    // Table simple responsive screen
    [theme.breakpoints.media.tableResponsive]: {
      '& .apexcharts-xaxis-label, .apexcharts-yaxis-label': {
        fontSize: getResponsiveSize(11, mobileRatio), // 11px
      },
      '& .tooltip-sparkline': {
        '& span': {
          fontSize: getResponsiveSize(13, mobileRatio), // 13px
        },
      },
    },
  },
});
